<template>
    <b-card no-body class="p-4 shadowed d-block"> <!-- d-block just to fix bug of image with IE11 -->
        <b-row no-gutters>
            <b-col md="4">
                <b-card-img :src="illustration"></b-card-img>
            </b-col>
            <b-col md="8" class="d-flex flex-column justify-content-between">
                <b-card-body>
                    <div>
                        <h5 class="text-primary">{{ title }}</h5>
                        {{ description }}
                    </div>
                    <div class="d-flex justify-content-end">
                        <b-button
                            variant="secondary"
                            @click="onClicked"
                            :to="buttonHref"
                            class="font-weight-bold"
                        >
                            {{ buttonText }}
                        </b-button>
                    </div>
                </b-card-body>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
    export default {
        props:{
            title: String,
            description: String,
            illustration: String,
            buttonText: String,
            buttonHref: String,
        },
        methods:{
            onClicked(){
                if(!this.buttonHref){
                    this.$emit('ctaClicked');
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .disabled {
        opacity: .9;
    }

    .card-progress{
        border-top-right-radius: 0;
        border-top-left-radius: 0;
    }
</style>
